// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();


export const getCountries = async() => {
   
    try {
        
        return await http.get<any>(`/v1/country`); 

    } catch (error) {
        console.log('getCountries ',error)
    }
}